<div class="app-main__inner">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon bg-mean-fruit rounded-circle"><i class="pe-7s-config text-white"></i></div>
        <div>
          Settings
          <div class="page-title-subheading">Global tracking mode, shift timings and alert threshold.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!loading">
    <div class="col-md-6 col-lg-4">
      <div class="mb-2 card settings-card">
        <div class="card-header d-flex align-items-center">
          <i class="header-icon fa fa-cog icon-gradient bg-tempting-azure mr-2"></i>
          Tracking Mode
        </div>
        <div class="card-body">
          <div class="form-group mb-0">
            <label class="required">Global Tracking Mode</label>
            <select class="form-select" [(ngModel)]="settings.globalTrackingMode">
              <option value="checkCount">Check / Count</option>
              <option value="startEnd">Start / End</option>
            </select>
            <small class="form-text text-muted">Used for products that don't override tracking mode individually.</small>
          </div>
          <div class="settings-card-save-row">
            <button
              class="btn btn-primary"
              [disabled]="savingTrackingMode || !isTrackingModeDirty"
              (click)="saveTrackingMode()"
            >
              <span class="spinner-border spinner-border-sm mr-1" *ngIf="savingTrackingMode"></span>
              <i class="fa fa-save mr-1" *ngIf="!savingTrackingMode"></i>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4">
      <div class="mb-2 card settings-card">
        <div class="card-header d-flex align-items-center">
          <i class="header-icon fa fa-clock icon-gradient bg-love-kiss mr-2"></i>
          Shift &amp; Alerts
        </div>
        <div class="card-body">
          <div class="form-group">
            <label class="required">Shift Start</label>
            <input class="form-control" type="time" [(ngModel)]="settings.shiftStart" />
          </div>
          <div class="form-group">
            <label class="required">Shift End</label>
            <input class="form-control" type="time" [(ngModel)]="settings.shiftEnd" />
          </div>
          <div class="form-group mb-0">
            <label class="required">Behind-Target Alert Threshold (%)</label>
            <input class="form-control" type="number" [(ngModel)]="settings.behindTargetAlertThresholdPct" />
            <small class="form-text text-muted">Alert fires when completion falls this far behind the expected pace.</small>
          </div>
          <div class="settings-card-save-row">
            <button class="btn btn-primary" [disabled]="savingShiftAlerts || !isShiftAlertsDirty" (click)="saveShiftAlerts()">
              <span class="spinner-border spinner-border-sm mr-1" *ngIf="savingShiftAlerts"></span>
              <i class="fa fa-save mr-1" *ngIf="!savingShiftAlerts"></i>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-4">
      <div class="mb-2 card settings-card settings-reasons-card">
        <div class="card-header d-flex align-items-center">
          <i class="header-icon fa fa-exclamation-triangle icon-gradient bg-grow-early mr-2"></i>
          Generic Downtime Reasons
        </div>
        <div class="card-body settings-reasons-body">
          <p class="text-muted small mb-3">
            Show up for every step's downtime report regardless of machine type — alongside whatever reasons that machine type defines of
            its own.
          </p>

          <div class="reason-add-row mb-3">
            <i class="fa fa-plus-circle reason-add-icon"></i>
            <input
              class="form-control reason-add-input"
              placeholder="Reason name"
              [(ngModel)]="newGenericReasonName"
              (keyup.enter)="addGenericReason()"
            />
            <button class="btn btn-primary reason-add-btn" type="button" (click)="addGenericReason()">Add</button>
          </div>

          <ul class="reason-list" *ngIf="genericDowntimeReasons.length">
            <li class="reason-item" *ngFor="let reason of genericDowntimeReasons">
              <span>{{ reason.name }}</span>
              <button class="btn btn-sm btn-outline-danger" (click)="deleteGenericReason(reason)" aria-label="Remove reason">
                <i class="fa fa-trash-alt"></i>
              </button>
            </li>
          </ul>
          <div class="reason-empty-state" *ngIf="!genericDowntimeReasons.length">
            <i class="fa fa-clipboard-list"></i>
            <span>No generic downtime reasons yet — add one above.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
